import { Injectable } from "@angular/core";
import {
  Http,
  Request,
  Response,
  Headers,
  RequestOptionsArgs,
  RequestMethod,
  ResponseContentType,
  RequestOptions,
} from "@angular/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";
import "rxjs/Rx";
import "rxjs/add/operator/toPromise";
import { ApiUrl } from "./apiUrls";
import { Router } from "@angular/router";

@Injectable()
export class CustomHttp {
  public token: string;
  public refreshToken: string;
  public refreshTokenCount: number = 0;
  public isTokenGenerated: boolean = false;

  constructor(
    private _http: Http,
    private appUrl: ApiUrl,
    private _router: Router,
  ) {}

  private checkForError(resp: Response): Response {
    if (resp.status >= 200 && resp.status < 300) {
      return resp;
    } else {
      const error = new Error(resp.statusText);
      //error['response']=resp;
      console.error(error);
      throw error;
    }
  }

  login(user: any): Observable<boolean> {
    var data =
      "username=" +
      user.UserName +
      "&password=" +
      user.Password +
      "&client_id=099153c2625149bc8ecb3e85e03f0022&grant_type=password";

    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    let options = new RequestOptions({ headers: headers });


    try {
      return this._http.post(this.appUrl.login, data, options)
      .map((response: Response) => {
        // login successful if there's a jwt token in the response

        var result = response.json();
        if (result.access_token) {
          // set token property
          this.token = result.access_token;
          // store username and jwt token in local storage to keep user.ts logged in between page refreshes
          var userData = UserData(result.access_token);
          var expiryDate = new Date();
          expiryDate.setSeconds(expiryDate.getSeconds() + result.expires_in);
          localStorage.setItem('currentUser', JSON.stringify({
            username: result.userName,
            token: result.access_token,
            UserId: userData.UserId,
            RoleId: userData.RoleId,
            UserTypeId: userData.UserTypeId,
            OrgId: userData.OrgId,
            UserName: userData.UserName,
            FullName: userData.FullName,
            Email: result.Email,
            DefaultCompanyId: userData.DefaultCompanyId,
            ExpiryDate: expiryDate,
            
            //  refreshToken: result.refresh_token,
          }));
          localStorage.setItem('UserName', JSON.stringify({ username: result.fullName }));
          localStorage.setItem('SessionId', JSON.stringify({ sessionId: result.sessionId }));
          // return true to indicate successful login
          return true;
        } else {
          // return false to indicate failed login
          return false;
        }
      });
    }
    catch (error) {
      console.error(error);
      throw error;
    }
  }

  // resetPassword(url: string, data: any): Observable<boolean> {
  //
  //   let headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
  //   let options = new RequestOptions({headers: headers});
  //   let resetData = JSON.stringify(data);
  //   return this._http.post(url, resetData, options)
  //     .map((res: Response) => {
  //       return res;
  //     })
  //     .catch(error => {
  //       if (error.status === 401) {
  //         return Observable.throw(error);
  //       }
  //     });
  // }
  resetPassword(url: string, data: any): Observable<any> {
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: "bearer " + "",
    });
    let body = JSON.stringify(data);
    let options = new RequestOptions({ headers: headers });
    return this._http
      .post(url, JSON.stringify(data), options)
      .map(this.checkForError)
      .catch((error) => {
        if (error.status === 401) {
          return this.RefreshToken().flatMap((newToken) => {
            let headers = new Headers({
              "Content-Type": "application/json",
              Authorization:
                "bearer " +
                JSON.parse(localStorage.getItem("currentUser")).token,
            });
            let body = JSON.stringify(data);
            return this._http.post(url, JSON.stringify(data), {
              headers: headers,
            });
          });
        } else {
          return Observable.throw(error);
        }
      });
  }

  forgotPassword(url: string): Observable<Response> {
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    let options = new RequestOptions({ headers: headers });
    return this._http
      .get(url, options)
      .map((res: Response) => {
        return res;
      })
      .catch((error) => {
        if (error.status === 401) {
          return Observable.throw(error);
        }
      });
  }

  get(url: string): Observable<Response> {
    if (JSON.parse(localStorage.getItem("currentUser")) == null) {
      this._router.navigate(["/login"]);
    } else {
      if (JSON.parse(localStorage.getItem("currentUser")).token != null) {
        let headers = new Headers({
          "Content-Type": "multipart/form-data",
          Authorization:
            "bearer " + JSON.parse(localStorage.getItem("currentUser")).token,
        });
        let options = new RequestOptions({ headers: headers });
        return this._http
          .get(url, options)
          .map((res: Response) => {
            return res;
          })
          .catch((error) => {
            if (error.status === 401) {
              // return this.RefreshToken().flatMap((newToken) => {
              //   let newheaders = new Headers({
              //     'Content-Type': 'application/json',
              //     'Authorization': 'bearer ' + JSON.parse(localStorage.getItem('currentUser')).token
              //   });
              //   return this._http.request(url, {headers: newheaders});
              // })
            } else {
              return Observable.throw(error);
            }
          });
      } else {
        this._router.navigate(["/login"]);
      }
    }
  }

  getDownload(url: string): Observable<Response> {
    if (JSON.parse(localStorage.getItem("currentUser")) == null) {
      this._router.navigate(["/login"]);
    }
    let headers = new Headers({
      "Content-Type": "application/json",
      Accept: "application/pdf",
      Authorization:
        "bearer " + JSON.parse(localStorage.getItem("currentUser")).token,
    });
    let options = new RequestOptions({ headers: headers });
    return this._http
      .post(url, { headers: headers })
      .map((res: Response) => {
        return res;
      })
      .catch((error) => {
        return Observable.throw(error);
      });
  }

  //   post(url: string, data: any): Observable<any> {
  //
  //     let headers = new Headers({
  //       'Content-Type': 'application/json',
  //       'Authorization': 'bearer ' + JSON.parse(localStorage.getItem('currentUser')).token
  //     });
  //     let body = JSON.stringify(data);
  //     let options = new RequestOptions({headers: headers});
  //     return this._http.post(url, JSON.stringify(data), options)
  //       .map(this.checkForError)
  //       .catch(error => {
  //         return Observable.throw(error);
  //         // if (error.status === 401) {
  //         //     return this.RefreshToken().flatMap((newToken) => {
  //         //         let headers = new Headers({ 'Content-Type': 'application/json','Authorization':'bearer '+this.token });
  //         //         let body = JSON.stringify(data);
  //         //         return this._http.post(url, JSON.stringify(data), { headers: headers });
  //         //     })
  //         // } else {
  //         //     return Observable.throw(error);
  //         // }
  //       }).map((res: Response) => res);
  //   }
  post(url: string, data: any, config?: RequestOptions): Observable<any> {
    if (JSON.parse(localStorage.getItem("currentUser")) == null) {
      this._router.navigate(["/login"]);
    } else {
      if (JSON.parse(localStorage.getItem("currentUser")).token != null) {
        let headers = new Headers({
          "Content-Type": "application/json",
          Authorization:
            "bearer " + JSON.parse(localStorage.getItem("currentUser")).token,
        });
        let responseType = config && config.responseType ? config.responseType : ResponseContentType.Json;

        let body = JSON.stringify(data);
        let options = new RequestOptions({ headers: headers, responseType: responseType });
        return this._http
          .post(url, JSON.stringify(data), options)
          .map(this.checkForError)
          .catch((error) => {
            if (error.status === 401) {
              return this.RefreshToken().flatMap((newToken) => {
                let headers = new Headers({
                  "Content-Type": "application/json",
                  Authorization:
                    "bearer " +
                    JSON.parse(localStorage.getItem("currentUser")).token,
                });
                let body = JSON.stringify(data);
                return this._http.post(url, JSON.stringify(data), {
                  headers: headers,
                });
              });
            } else {
              return Observable.throw(error);
            }
          });
      } else {
        this._router.navigate(["/login"]);
      }
    }
  }

  postUpload(url: string, data: any): Observable<any> {
    if (JSON.parse(localStorage.getItem("currentUser")) == null) {
      this._router.navigate(["/login"]);
    }
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization:
        "bearer " + JSON.parse(localStorage.getItem("currentUser")).token,
    });
    headers.delete("Content-Type");
    return this._http
      .post(url, data, { headers: headers })
      .map((res: Response) => res)
      .catch((error) => {
        if (error.status === 401) {
          return this.RefreshToken().flatMap((newToken) => {
            let headers = new Headers({
              "Content-Type": "application/json",
              Authorization:
                "bearer " +
                JSON.parse(localStorage.getItem("currentUser")).token,
            });
            let body = JSON.stringify(data);
            return this._http.post(url, JSON.stringify(data), {
              headers: headers,
            });
          });
        } else {
          return Observable.throw(error);
        }
      });
  }

  postUploadmodel(url: string, data: any): Observable<any> {
    if (JSON.parse(localStorage.getItem("currentUser")).token != null) {
      let headers = new Headers({
        "Content-Type": false,
        Authorization:
          "bearer " + JSON.parse(localStorage.getItem("currentUser")).token,
      });
      headers.delete("Content-Type");
      return this._http
        .post(url, data, { headers: headers })
        .map((res: Response) => res)
        .catch((error) => {
          if (error.status === 401) {
            return this.RefreshToken().flatMap((newToken) => {
              let headers = new Headers({
                "Content-Type": "application/json",
                Authorization:
                  "bearer " +
                  JSON.parse(localStorage.getItem("currentUser")).token,
              });
              let body = JSON.stringify(data);
              return this._http.post(url, JSON.stringify(data), {
                headers: headers,
              });
            });
          } else {
            return Observable.throw(error);
          }
        });
    } else {
      this._router.navigate(["/login"]);
    }
  }

  // put(url:string, data:any, args?: RequestOptionsArgs) : Observable<any> {
  //     if (args == null) args = {};
  //     if (args.headers === undefined) args.headers = this.headers;
  //
  //     return this._http.put(url, JSON.stringify(data), args)
  //         .map((res: Response) => CustomHttp.json(res))
  //         .catch(this.handleError);
  // }
  //
  // remove(url: string, data?: any, args?: RequestOptionsArgs): Observable<any> {
  //     if (args == null) args = {};
  //
  //     args.url = url;
  //     args.method = RequestMethod.Delete;
  //     if (!args.headers) args.headers = this.headers;
  //     args.body  = data ? JSON.stringify(data) : null;
  //
  //     return this._http.request(new Request(<RequestArgs>args))
  //         .map((res: Response) => CustomHttp.json(res))
  //         .catch(this.handleError);
  // }

  private static json(res: Response): any {
    return res.text() === "" ? res : res.json();
  }

  private handleError(error: any) {
    return Observable.throw(error);
  }

  logout(): void {
    // clear token remove user.ts from local storage to log user.ts out

    this.token = null;
    localStorage.removeItem("currentUser");
  }

  RefreshToken() {
    var data =
      "refresh_token=" +
      JSON.parse(localStorage.getItem("currentUser")).refreshToken +
      "&clientid=Website&grant_type=refresh_token";
    //refreshToken
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return this._http
      .post(this.appUrl.login, data, { headers: headers })
      .map((response: Response) => {
        let token = response.json().access_token;
        let refreshToken = response.json().refresh_token;
        let roleId = response.json().RoleId;
        if (token) {
          // set token property
          this.token = token;
          this.refreshToken = refreshToken;
          // store username and jwt token in local storage to keep user.ts logged in between page refreshes
          localStorage.setItem(
            "currentUser",
            JSON.stringify({
              username: "",
              token: token,
              RoleId: roleId,
              refreshToken: refreshToken,
            }),
          );
          //
          // localStorage.setItem('currentUser', JSON.stringify({
          //   username: result.userName,
          //   token: result.access_token,
          //   RoleId:result.RoleId,
          //   uniqueRandomId:result.UniqueRandomId,
          //   clientTypeId:result.ClientTypeId,
          //   accHoldingTypeId:result.AccHoldingTypeId,
          //   refreshToken: result.refresh_token,
          // }));

          this.isTokenGenerated = true;
          // // return true to indicate successful login
          return true;
        } else {
          // return false to indicate failed login
          return false;
        }
      });
  }
}
function UserData(token: any) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64));
}
